export const build = { date:"2026-04-08.1448", stage:"alpha" }
